import { DraftMerchantResponseDto, MerchantResponseDto } from "@/api/paymentApi";
import sessionsApi from '@/api/sessions';
import { getDraftMerchant, getMerchant, getMerchantConfiguration, getMerchantFiles } from "@/service/merchantService";
import { storeAppDetails, storeDraftMerchantDetails, storeFromSessionPrefillData, storeMerchantConfiguration, storeMerchantDetails } from "@/service/saveInStore";

export const getAndStoreSession = async () => {
    const session = await sessionsApi.fetchSession();
    storeAppDetails(session)
    let merchantResponse: MerchantResponseDto | DraftMerchantResponseDto | undefined = undefined;
    if (session.merchant_id) {
        merchantResponse = await getAndStoreMerchantAndConfiguration(session.merchant_id);
    } 
    
    if (session.onboarding_draft_id) {
        merchantResponse = await getAndStoreDraftMerchant(session.onboarding_draft_id);
    }
    
    storeFromSessionPrefillData(session, merchantResponse);
    return session;
}

async function getAndStoreDraftMerchant(draftMerchantId): Promise<DraftMerchantResponseDto> {
    const draftResponse: DraftMerchantResponseDto = await getDraftMerchant(draftMerchantId)
    storeDraftMerchantDetails(draftResponse)
    return draftResponse;
}

export async function getAndStoreMerchant(merchantId): Promise<MerchantResponseDto> {
    const merchantResponse: MerchantResponseDto = await getMerchant(merchantId)
    storeMerchantDetails(merchantResponse)
    return merchantResponse;
}

export async function getAndStoreMerchantAndConfiguration(merchantId) {
    const merchantResponse = await getAndStoreMerchant(merchantId);
    await getAndStoreMerchantConfiguration(merchantId);
    return merchantResponse;
}

export async function getAndStoreMerchantConfiguration(merchantId) {
    const configurationResponse = await getMerchantConfiguration(merchantId)
    storeMerchantConfiguration(configurationResponse)
    return configurationResponse;
}

export const getAndStoreMerchantFiles = async (merchantId) => {
    const merchantFileResponse: any = await getMerchantFiles(merchantId)
    return merchantFileResponse;
}
